// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n.iFviGZTr-jp4L1GSQW45n {\r\n    min-height: 72px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 48px 0 24px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    margin-right: 72px;    \r\n}\r\n\r\n.Wjwees1kY_W1xtq4o-vNw {\r\n    margin: 0 24px;\r\n    flex: 1;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    padding-bottom: 24px;\r\n}\r\n\r\n\r\n._3SvTuGnz58ftka7RRE6BJv {\r\n    padding: 12px 24px 24px 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    height: 72px;\r\n}\r\n\r\n._3SvTuGnz58ftka7RRE6BJv > * {\r\n    margin-left: 12px;\r\n}\r\n    ", ""]);
// Exports
exports.locals = {
	"header": "iFviGZTr-jp4L1GSQW45n",
	"content": "Wjwees1kY_W1xtq4o-vNw",
	"footer": "_3SvTuGnz58ftka7RRE6BJv"
};
module.exports = exports;
